<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/zhaoshang/customer' }">客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>修改成交项目</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">修改成交项目</span>
      </div>

      <el-form :model="form" ref="formRef" :rules="formRules" label-width="120px" :inline="false" size="normal">
        <div class="divContainer">
          <div class="leftDiv">
            <!-- 项目名称 -->
            <el-form-item label="项目名称：" prop="projectName">
              <el-input v-model="form.projectName" placeholder="品牌名+地标，如美滋滋西安钟楼店" maxlength="50"></el-input>
            </el-form-item>

            <!-- 客户信息 -->
            <el-form-item label="客户：">
              <el-input v-model="form.customerName" :disabled="true" maxlength="50"></el-input>
            </el-form-item>

            <!-- 签约人 -->
            <el-form-item label="签约人：" prop="signerId">
              <el-select :disabled="true" v-model="form.signerId" placeholder="请选择签约人" style="width: 100%">
                <el-option v-for="item in employeeList" :key="item._id" :label="item.name" :value="item._id"></el-option>
              </el-select>
            </el-form-item>

            <!-- 签约时间 -->
            <el-form-item label="签约时间：" prop="dealDate">
              <el-date-picker
                :disabled="signDateReadonly()"
                v-model="form.dealDate"
                type="date"
                placeholder="请选择签约时间"
                style="width: 100%"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

            <!-- 签约类型 -->
            <el-form-item label="签约类型：" prop="signType">
              <el-select :disabled="isOtherType" v-model="form.signType" placeholder="请选择签约类型" style="width: 100%">
                <el-option v-for="item in availableSignTypes" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>

            <!-- 地址 -->
            <el-form-item v-if="!isOtherType" label="地址：" prop="address">
              <div>
                <el-input v-model="form.address" placeholder="请输入地址" maxlength="100" style="width:70%;margin-right:5px"></el-input>
                <el-button type="primary" size="small" @click="locateClickHandler">定位</el-button>
              </div>
              <div v-if="form.province && form.city && form.district">
                <div class="descText">{{ form.area }} {{ form.province }}-{{ form.city }}-{{ form.district }} [{{form.lat}}/{{form.lng}}]</div>
              </div>
            </el-form-item>

            <!-- 督导 -->
            <el-form-item v-if="!isOtherType" label="督导：" prop="supervisorId">
              <el-select v-model="form.supervisorId" :disabled="handoverStatus >= 2" placeholder="请选择督导" style="width: 100%" @change="onSupervisorChange">
                <el-option v-for="item in supervisorList" :key="item._id" :label="item.name" :value="item._id"></el-option>
              </el-select>
              <div v-if="handoverStatus >= 2" style="color: #909399; font-size: 12px; line-height: 1.5;">项目已移交且已被接收，督导不可修改</div>
            </el-form-item>

            <!-- 商圈范围 -->
            <el-form-item v-if="!isOtherType" label="商圈范围：" prop="range">
              <el-input-number v-model="form.range" :min="0.1" :max="50" :precision="1" :step="0.5"
                style="width: 150px"></el-input-number>
              <span style="margin-left: 10px; color: #909399;">公里</span>
            </el-form-item>

            <!-- 抽佣比例 -->
            <el-form-item v-if="!isOtherType" label="抽佣比例：" prop="commissionRate">
              <el-input-number v-model="form.commissionRate" :min="0" :max="100" :precision="1" :step="0.5" placeholder="请输入抽佣比例" style="width: 150px"></el-input-number>
              <span style="margin-left: 10px; color: #909399;">%</span>
            </el-form-item>

            <!-- 备注 -->
            <el-form-item label="项目备注：" prop="remark">
              <el-input v-model="form.remark" type="textarea" placeholder="与项目或老板相关的备注信息（最多500字符）。比如：这是老板的二店。再比如：老板说先锁定商圈，后面再决定何时开张。" maxlength="500" rows="4"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="okClickHandler">保存修改</el-button>
              <el-button @click="goBack">返回</el-button>
            </el-form-item>
          </div>
          <div class="midDiv" v-if="!isOtherType">
            <!-- 附加信息 -->
            <el-card shadow="never" style="background-color: #f5f7fa;">
              <el-form-item size="mini" label="评估单量：" label-width="100px" prop="additionalInfo.评估单量">
                <el-input size='mini' v-model="form.additionalInfo['评估单量']" :placeholder="`请输入评估单量`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="客户签约代表：" label-width="120px" prop="additionalInfo.客户签约代表">
                <el-input size='mini' v-model="form.additionalInfo['客户签约代表']" :placeholder="`请输入客户签约代表`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="联系电话：" label-width="100px" prop="additionalInfo.联系电话">
                <el-input size='mini' v-model="form.additionalInfo['联系电话']" :placeholder="`请输入联系电话`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="店铺面积：" label-width="100px">
                <el-input size='mini' v-model="form.additionalInfo['店铺面积']" :placeholder="`请输入店铺面积`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="店铺电力：" label-width="100px">
                <el-input size='mini' v-model="form.additionalInfo['店铺电力']" :placeholder="`请输入店铺电力`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="店铺下水：" label-width="100px">
                <el-input size='mini' v-model="form.additionalInfo['店铺下水']" :placeholder="`请输入店铺下水`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="燃气：" label-width="100px">
                <el-input size='mini' v-model="form.additionalInfo['燃气']" :placeholder="`请输入燃气`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="房租：" label-width="100px" prop="additionalInfo.房租">
                <el-input size='mini' v-model="form.additionalInfo['房租']" :placeholder="`请输入房租（填入0表示不确定）`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="运费：" label-width="100px">
                <el-input size='mini' v-model="form.additionalInfo['运费']" :placeholder="`请输入运费`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="餐饮经验：" label-width="100px" prop="additionalInfo.餐饮经验">
                <el-input size='mini' v-model="form.additionalInfo['餐饮经验']" :placeholder="`请输入餐饮经验`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="是否多开：" label-width="100px" prop="additionalInfo.是否多开">
                <el-input size='mini' v-model="form.additionalInfo['是否多开']" :placeholder="`请输入是否多开`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="是否二店：" label-width="100px">
                <el-input size='mini' v-model="form.additionalInfo['是否二店']" :placeholder="`请输入是否二店`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="是否翻新：" label-width="100px" prop="additionalInfo.是否翻新">
                <el-input size='mini' v-model="form.additionalInfo['是否翻新']" :placeholder="`请输入是否翻新`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="商圈已测：" label-width="100px" prop="additionalInfo.商圈已测">
                <el-input size='mini' v-model="form.additionalInfo['商圈已测']" :placeholder="`请填是或否，确定商圈不重叠`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="车尾交接：" label-width="100px">
                <el-input size='mini' v-model="form.additionalInfo['车尾交接']" :placeholder="`请输入车尾交接情况`"></el-input>
              </el-form-item>
              <el-form-item size="mini" label="情况说明：" label-width="100px" prop="additionalInfo.情况说明">
                <el-input size='mini' type="textarea" :rows="4" v-model="form.additionalInfo['情况说明']" :placeholder="`请输入情况说明`"></el-input>
              </el-form-item>
            </el-card>
          </div>

          <!-- ==================== 第三列：首批物料备忘（文本与截图至少填一项） ==================== -->
          <div class="rightDiv" v-if="!isOtherType">
            <el-card shadow="never" style="background-color: #f5f7fa;">
              <div class="memoCardHeader">首批物料备忘（必填一项）</div>
              <el-form-item size="mini" label-width="0">
                <el-input size='mini' type="textarea" :rows="5" maxlength="200" v-model="form.firstMaterialMemo.text"
                  placeholder="请填写与客户约定的首批采购物料口径，如：首批物料金额7200元（老标准）"></el-input>
                <image-upload v-model="form.firstMaterialMemo.images" :limit="6" :active="true" @preview="handleMemoPreview" />
                <div class="memoTip">文本与截图至少填一项；支持点击/拖拽/Ctrl+V 粘贴上传截图（最多6张）；该备忘将同步给筹建督导与运营</div>
              </el-form-item>
            </el-card>
          </div>
        </div>

      </el-form>

    </el-card>

    <!-- 地图面板 -->
    <el-dialog
      title="选择坐标"
      :visible.sync="mapPreviewVisible"
      top="10vh"
      width="1000px"
      @opened='openMap'
      @close="closeMap">
      <div class="container">
        <div id="mapContainer"></div>
        <div id="mapText">
          <p>地址：{{form.address}}</p>
          <p>大区：{{form.area}}</p>
          <p>省份：{{form.province}}</p>
          <p>城市：{{form.city}}</p>
          <p>区县：{{form.district}}</p>
          <p>纬度：{{form.lat}}</p>
          <p>经度：{{form.lng}}</p>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="mapPreviewVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 操作记录（detail 接口附带） -->
    <el-card class="box-card" style="margin-top: 15px" v-if="operationLogs.length > 0">
      <div slot="header"><span style="font-weight: bold">操作记录</span></div>
      <el-table :data="operationLogs" border size="mini">
        <el-table-column label="动作" width="130">
          <template slot-scope="scope">{{ actionText(scope.row.action) }}</template>
        </el-table-column>
        <el-table-column prop="operatorName" label="操作人" width="100"></el-table-column>
        <el-table-column prop="remark" label="说明" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column label="时间" width="150">
          <template slot-scope="scope">{{ scope.row.createDate | timeFormat }}</template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
import { storeTypeList, getAreaName, mapKey, brandList } from '@/utility/staticData'
import { actionText } from '../../utils/operationLogMap'
import ImageUpload from '@/components/ImageUpload.vue'
export default {
  components: { ImageUpload },
  filters: {
    timeFormat (val) {
      if (!val) return '-'
      const d = new Date(val)
      const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    }
  },
  data () {
    return {
      projectId: '', // 项目ID
      accountInfo: {},

      // 操作日志（detail 接口附带）
      operationLogs: [],
      actionText,
      handoverStatus: 0, // 移交状态
      // 表单数据
      form: {
        projectName: '', // 项目名称
        customerName: '', // 客户名称

        signerId: '', // 签约人ID
        signerName: '', // 签约人姓名
        dealDate: '', // 签约时间
        signType: '', // 签约类型

        address: '', // 地址
        area: '', // 区域
        province: '', // 省份
        city: '', // 城市
        district: '', // 区县
        lat: '', // 纬度
        lng: '', // 经度

        supervisorId: '', // 督导ID
        supervisorName: '', // 督导姓名
        additionalInfo: {
          评估单量: '',
          客户签约代表: '',
          联系电话: '',
          店铺面积: '',
          店铺电力: '',
          店铺下水: '',
          燃气: '',
          房租: '',
          运费: '',
          餐饮经验: '',
          是否多开: '',
          是否二店: '',
          是否翻新: '',
          商圈已测: '',
          车尾交接: '',
          情况说明: ''
        },
        // 首批物料备忘（text 文本 + images 截图相对路径数组）
        firstMaterialMemo: { text: '', images: [] },
        remark: '', // 备注
        range: 4, // 商圈范围（公里）
        commissionRate: 0 // 抽佣比例
      },

      // 员工列表
      employeeList: [],
      // 督导列表
      supervisorList: [],
      // 签约类型列表
      signTypeList: storeTypeList,

      // 表单验证规则
      formRules: {
        projectName: [
          { type: 'string', required: true, message: '请输入项目名称', trigger: 'blur' },
          { type: 'string', min: 2, max: 50, message: '项目名称必须为2-50个字符', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback()
              } else if (this.form.signType === '其他') {
                callback()
              } else {
                const startsWithBrand = brandList.some(brand => value.startsWith(brand))
                if (!startsWithBrand) {
                  callback(new Error('项目名称必须以品牌名称开头（如：美滋滋西安店)'))
                } else {
                  callback()
                }
              }
            },
            trigger: 'blur'
          }
        ],
        signerId: [
          { required: true, message: '请选择签约人', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        supervisorId: [
          { message: '请选择督导', trigger: 'change' }
        ],
        remark: [
          { type: 'string', max: 500, message: '备注信息不能超过500个字符', trigger: 'blur' }
        ],
        commissionRate: [
          { required: true, message: '请输入抽佣比例', trigger: 'blur' },
          { type: 'number', min: 0, max: 100, message: '抽佣比例范围为0-100', trigger: 'blur' }
        ],
        additionalInfo: {
          评估单量: { required: true, message: '请输入评估单量', trigger: 'blur' },
          客户签约代表: { required: true, message: '请输入客户签约代表', trigger: 'blur' },
          联系电话: { required: true, message: '请输入联系电话', trigger: 'blur' },
          房租: { required: true, message: '请输入房租', trigger: 'blur' },
          餐饮经验: { required: true, message: '请输入餐饮经验', trigger: 'blur' },
          是否多开: { required: true, message: '请输入是否多开', trigger: 'blur' },
          是否翻新: { required: true, message: '请输入是否翻新', trigger: 'blur' },
          商圈已测: { required: true, message: '请填是或否，确定商圈不重叠', trigger: 'blur' },
          情况说明: { required: true, message: '请输入情况说明', trigger: 'blur' }
        }
      },

      // 地图相关
      map: null, // 地图对象
      script: null, // 脚本对象
      scriptLoading: null, // 脚本加载遮罩
      getAreaName: getAreaName, // 获取区域名称的方法
      mapPreviewVisible: false, // 地图预览可见性
      brandList: brandList // 品牌列表
    }
  },
  computed: {
    isOtherType () {
      return this.form.signType === '其他'
    },
    availableSignTypes () {
      if (this.isOtherType) {
        return ['其他']
      }
      return this.signTypeList.filter(item => item !== '其他')
    }
  },
  created () {
    this.getAccountInfo()
    // 从路由参数获取项目ID
    this.projectId = this.$route.params.id
    if (!this.projectId) {
      this.$message.error('缺少项目ID参数')
      this.goBack()
      return
    }
    // 加载数据
    this.loadData()
    this.loadScript()
  },
  beforeDestroy () {
    this.unloadScript()
  },
  methods: {
    // 加载地图脚本
    loadScript () {
      this.scriptLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      window.initMap = this.initMap
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = `https://map.qq.com/api/gljs?v=1.exp&key=${mapKey}&callback=initMap`
      document.body.appendChild(script)
      this.script = script
    },

    // 初始化地图
    initMap () {
      this.scriptLoading.close()
    },

    // 卸载地图脚本
    unloadScript () {
      if (this.script) {
        document.body.removeChild(this.script)
        this.script = null
        this.map = null
        delete window.TMap
        delete window.initMap
      }
    },

    // 加载所有数据
    async loadData () {
      try {
        await Promise.all([
          this.getEmployeeList(),
          this.getSupervisorList()
        ])
        // 所有列表加载完成后，加载项目详情
        await this.getProjectDetail()
      } catch (error) {
        console.error('加载数据失败:', error)
      }
    },

    // 获取项目详情
    async getProjectDetail () {
      try {
        const { data: res } = await this.$http.get(`zhaoshang/project/detail/${this.projectId}`)
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          this.goBack()
          return
        }
        const project = res.data
        if (project.transferOutInfo && project.transferOutInfo.toProjectId) {
          this.$message.warning('已转让项目仅支持修改备注')
          this.goBack()
          return
        }
        // 操作记录（detail 接口附带，最近 20 条）
        this.operationLogs = res.data.operationLogs || []
        // 填充表单数据
        this.form.projectName = project.projectName
        this.form.customerName = project.customerName
        this.form.dealDate = this.convertToBeijingDate(project.dealDate)
        this.form.signType = project.signType

        this.form.signerId = project.signerId
        this.form.signerName = project.signerName

        // storeMap 可能不存在（"其他"类型无门店地图）
        const storeMap = project.storeMap || {}
        this.form.address = storeMap.address || ''
        this.form.province = storeMap.province || ''
        this.form.city = storeMap.city || ''
        this.form.district = storeMap.district || ''
        this.form.lat = storeMap.lat || ''
        this.form.lng = storeMap.lng || ''
        this.form.area = storeMap.area || ''
        this.form.range = storeMap.range || 5

        this.form.supervisorId = project.supervisorId || ''
        this.form.supervisorName = project.supervisorName || ''
        this.form.additionalInfo = Object.assign({}, this.form.additionalInfo, project.additionalInfo || {})
        // 首批物料备忘回显：历史项目字段为 undefined，初始化兑底空对象后再回填
        // （图片为相对路径，ImageUpload 组件内部自动拼 base 展示）
        const memo = project.firstMaterialMemo || { text: '', images: [] }
        this.form.firstMaterialMemo = { text: memo.text || '', images: [...(memo.images || [])] }
        this.form.remark = project.remark || ''
        this.form.commissionRate = project.commissionRate ?? 0
        // 保存移交状态
        this.handoverStatus = project.handoverStatus || 0
      } catch (error) {
        console.error('获取项目详情失败:', error)
        this.$message.error('获取项目详情失败')
        this.goBack()
      }
    },

    // 将ISO时间转换为北京时间日期（YYYY-MM-DD格式）
    convertToBeijingDate (isoDateString) {
      if (!isoDateString) return ''
      try {
        // 创建Date对象，ISO时间会自动按照本地时区解析
        const date = new Date(isoDateString)
        // 转换为北京时间（UTC+8）
        const beijingTime = new Date(date.getTime() + (8 * 60 * 60 * 1000))
        // 获取UTC时间的年月日
        const year = beijingTime.getUTCFullYear()
        const month = String(beijingTime.getUTCMonth() + 1).padStart(2, '0')
        const day = String(beijingTime.getUTCDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      } catch (error) {
        console.error('日期转换失败:', error)
        return ''
      }
    },

    // 获取当前登录账号的信息
    getAccountInfo () {
      this.accountInfo.level = window.sessionStorage.getItem('level')
      this.accountInfo.employeeId = window.sessionStorage.getItem('employeeId') || ''
      this.accountInfo.employeeName = window.sessionStorage.getItem('employeeName') || ''
      this.accountInfo.department = window.sessionStorage.getItem('department') || ''
      this.accountInfo.job = window.sessionStorage.getItem('job') || ''
      this.accountInfo.bindDxqId = window.sessionStorage.getItem('bindDxqId') || ''
    },

    // 判断签约日期是否为只读状态
    signDateReadonly () {
      return this.accountInfo.level > 1 && this.accountInfo.job !== '总监'
    },

    // 备忘截图预览（ImageUpload 的 preview 事件给完整 URL，新窗口打开）
    handleMemoPreview (imageUrl) {
      if (imageUrl) window.open(imageUrl)
    },

    // 获取督导列表
    async getSupervisorList () {
      try {
        const { data: res } = await this.$http.get('zhaoshang/project/getSupervisors')
        if (res.meta.status !== 200) {
          return this.$message.error(res.meta.msg)
        }
        this.supervisorList = res.data || []
      } catch (error) {
        this.$message.error('获取督导列表失败')
      }
    },

    // 获取员工列表
    async getEmployeeList () {
      try {
        const { data: res } = await this.$http.get('zhaoshang/customer/employees')
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return Promise.reject(new Error(res.meta.msg))
        }
        this.employeeList = res.data || []
        return Promise.resolve()
      } catch (error) {
        this.$message.error('获取员工列表失败')
        return Promise.reject(error)
      }
    },

    // 督导选择变化
    onSupervisorChange (value) {
      const supervisor = this.supervisorList.find(item => item._id === value)
      if (supervisor) {
        this.form.supervisorName = supervisor.name
      }
    },

    // 点击保存按钮
    async okClickHandler () {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false

        // 首批物料备忘：联合校验——文本与截图至少填一项（"其他"类型无此区块不校验）
        if (!this.isOtherType) {
          const memo = this.form.firstMaterialMemo
          if (!(memo.text && memo.text.trim()) && !memo.images.length) {
            return this.$message.error('请填写首批物料备忘：文本或截图至少提供一项')
          }
        }

        const submitData = {
          projectName: this.form.projectName,
          signType: this.form.signType,
          dealDate: this.form.dealDate,
          remark: this.form.remark || ''
        }

        if (!this.isOtherType) {
          submitData.address = this.form.address
          submitData.lat = this.form.lat
          submitData.lng = this.form.lng
          submitData.area = this.form.area
          submitData.province = this.form.province
          submitData.city = this.form.city
          submitData.district = this.form.district
          submitData.supervisorId = this.form.supervisorId
          submitData.supervisorName = this.form.supervisorName
          submitData.additionalInfo = this.form.additionalInfo
          submitData.range = this.form.range
          submitData.commissionRate = this.form.commissionRate
          // 首批物料备忘随表单提交
          submitData.firstMaterialMemo = {
            text: (this.form.firstMaterialMemo.text || '').trim(),
            images: this.form.firstMaterialMemo.images
          }
        }

        try {
          const { data: res } = await this.$http.put(`zhaoshang/project/modify/${this.projectId}`, submitData)
          if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
          this.$message.success(res.meta.msg)
          this.goBack()
        } catch (error) {
          console.error('修改项目失败:', error)
          this.$message.error('修改项目失败')
        }
      })
    },

    // 点击定位按钮
    async locateClickHandler () {
      if (!this.form.address) {
        return this.$message.error('请先输入地址')
      }
      try {
        const { data: res } = await this.$http.get('map/geocoder', {
          params: {
            address: this.form.address
          }
        })

        if (res.meta.status === 200) {
          this.form.province = res.data.address_components.province
          this.form.city = res.data.address_components.city
          this.form.district = res.data.address_components.district
          this.form.lat = res.data.location.lat
          this.form.lng = res.data.location.lng
          this.form.area = this.getAreaName(this.form.province)
          this.mapPreviewVisible = true
          this.$message.success('定位成功')
        } else {
          this.$message.error(res.meta.msg || '定位失败，请检查地址是否正确')
        }
      } catch (error) {
        console.log('定位失败:', error)
        this.$message.error('定位失败，请检查地址是否正确')
      }
    },

    // 地图打开
    openMap () {
      const center = new window.TMap.LatLng(this.form.lat, this.form.lng)

      this.map = new window.TMap.Map('mapContainer', {
        center: center,
        zoom: 13,
        viewMode: '2D',
        showControl: false
      })
      this.marker = new window.TMap.MultiMarker({
        map: this.map,
        styles: {
          // 点标记样式
          marker: new window.TMap.MarkerStyle({
            width: 40, // 样式宽
            height: 60, // 样式高
            anchor: { x: 20, y: 60 } // 描点位置
          })
        }
      })
      this.marker.add({
        id: 'mark',
        styleId: 'marker',
        position: new window.TMap.LatLng(this.form.lat, this.form.lng)
      })
    },

    // 地图关闭
    closeMap () {
      this.map.destroy()
    },

    // 返回
    goBack () {
      // 获取传递过来的状态参数
      const query = { ...this.$route.query }

      // 构建返回URL
      const queryString = Object.keys(query).length > 0
        ? '?' + Object.entries(query).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')
        : '?tabs=project'

      this.$router.push('/zhaoshang/customer' + queryString)
    }
  }
}
</script>

<style lang="less" scoped>
.divContainer{
  display: flex;
  justify-content: space-between;
}
.leftDiv{
  width:450px;
  // background-color: #8eb1e6;
}
.midDiv{
  width:420px;
  // background-color: #daf579;
}
.rightDiv{
  width:400px;
  // background-color: #ee90db;
}
// 第三列备忘卡片头部
.memoCardHeader{
  font-size: 14px;
  font-weight: bold;
  color: #B88230;
  margin-bottom: 12px;
}
// 备忘提示文案
.memoTip{
  font-size: 12px;
  color: #E6A23C;
  line-height: 1.6;
  margin-top: 4px;
}
.descText{
  font-size: 12px;
  color: #999;
}
.container{
  display: flex;
}
#mapContainer{
  height:600px;
  width:600px;
}
#mapText{
  padding: 20px;
  font-size: 14px;
  line-height: 1.5;
  color: #999;
}
</style>
